// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tu24","delete":"styles_delete__3o65u","update":"styles_update__2FQX6","add":"styles_add__3gWXB"};